import Vue from 'vue'

import Layout from './Layout';

Vue.component('module-layout', Layout)